import gql from 'graphql-tag';

export const mutationViewIntegrationThread = gql`
  mutation viewIntegrationThread (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    viewIntegrationThread (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationViewIntegrationThread;
